import {
  ENTITY_ICONS,
  ENTITY_TYPE_LABELS,
  type EntityType,
} from "./entityIcons";

export interface EntityIconProps {
  /** The record type whose icon to draw, from `ENTITY_ICONS`. */
  type: EntityType;
  /** Pixels, or a CSS length such as `1em`. @default 16 */
  size?: number | string;
  /** @default 1.75 */
  strokeWidth?: number;
  /** Set on the icon's `<svg>`, as for its colour or a hover effect. */
  className?: string;
  /**
   * Names the icon for assistive tech, for an icon shown without its type
   * written beside it: `true` uses the type's label ("Dataset"), a string
   * replaces it. Left out, the icon is decorative and hidden.
   */
  title?: true | string;
}

/**
 * The icon for a record type, from `ENTITY_ICONS`, the same everywhere it
 * appears. Carries `data-entity-icon`, so a test can check which type's icon
 * it is without naming the glyph.
 */
export function EntityIcon({
  type,
  size = 16,
  strokeWidth = 1.75,
  className,
  title,
}: EntityIconProps) {
  const Icon = ENTITY_ICONS[type];
  const label = title === true ? ENTITY_TYPE_LABELS[type] : title;
  return (
    <Icon
      size={size}
      strokeWidth={strokeWidth}
      className={className}
      data-entity-icon={type}
      aria-hidden={label === undefined}
      aria-label={label}
      role={label === undefined ? undefined : "img"}
    />
  );
}
